import React from 'react'
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import './history.css'

export default function OppositeContentTimeline() {
  return (
    <section id='history'>
    <h5>Uncovering</h5>
    <h2>GX History</h2>
      <React.Fragment>
        <Timeline position="alternate">
          <TimelineItem>
            <TimelineOppositeContent color="var(--color-primary)">
              Nov. 2021
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>🚀 GX Discord and Twitter created.</TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent color="var(--color-primary)">
              Jan. 2022
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>📊 GX infographics shared with the community.</TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent color="var(--color-primary)">
              Apr. 2022
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>🛰️ Announcement of the GX Collective.</TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent color="var(--color-primary)">
              Jul. 2022
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>🎨 Set 1 x Fort Gotten - consisting of seven unique GX derivative artworks.</TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent color="var(--color-primary)">
              Oct. 2022
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>💻 GX website launch.</TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent color="var(--color-primary)">
              Dec. 2022
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>🎨 Set 2 x DALL-E - AI generated GX.</TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent color="var(--color-primary)">
              Dec. 2023
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>🎨 GX Collective policy closed.</TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent color="var(--color-primary)">
              Mar. 2024
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>🚧 GXBudz website update for v2 artwork.</TimelineContent>
          </TimelineItem>
        </Timeline>
      </React.Fragment>
    </section>
  );
}
